(ns app.domain.call-to-action.model
  (:require [app.domain.group.model :as group-model]
            [app.i18n.model :as i18n-model]))

(defmethod i18n-model/get-localized-string-attrs :entity.type/call-to-action [_]
  [:call-to-action/title :call-to-action/subtitle :call-to-action/content])

(defmethod group-model/get-authority-group :entity.type/call-to-action
  [call-to-action]
  (:call-to-action/group call-to-action))

(def dynamic-call-to-action-kinds
  [:dynamic-call-to-action.kind/committee-meetings])
